<template>
  <div id="reportes" class="zindex100">
    <div
      class="separador text-center py-5"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <div class="mt-5 pt-5">&nbsp;</div>
      <p class="fXG blanco">Tickets Registrados COMPLETO</p>
      <p>
        <button @click="logout" class="btn btn-info">Cerrar sesión</button>
      </p>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-6 py-5">
          <router-link class="btn btn-danger" to="/reportes/descarga">
            Descarga de usuarios &raquo;
          </router-link>
        </div>
      </div>

      <b-tabs content-class="mt-3 row zindex100">
        <b-tab title="Participaciones">
          <div>
            <div class="col-12 blanco pt-5 pb-3">
              <span class="blockd fG">Tickets</span>
              (Total: {{ tickets.length }})
            </div>

            <div class="col-12 zindex100 mb-3">
              <download-excel
                :data="tickets"
                name="Tickets - Solo en Dominos.xls"
              >
                <button class="btn btn-danger">Exportar Tickets</button>
              </download-excel>
            </div>

            <div class="col-12 blanco">
              sólo para descarga
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <!-- Modal detalle ticket -->
    <b-modal
      id="modal-detalle"
      v-if="selectedTicket"
      size="xl"
      hide-footer
      title=""
      modal-class="modal-detalle-custom"
    >
      <!-- Botón cerrar -->
      <button
        type="button"
        class="close-modal"
        @click="$bvModal.hide('modal-detalle')"
      >
        &times;
      </button>

      <!-- Título -->
      <h4 class="modal-title text-center pt-3">Detalle del Ticket</h4>

      <div class="table-responsive mt-3">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Participa</th>
              <th>Max Fresh</th>
              <th>Descripción</th>
              <th>SKU</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in selectedTicket.ticket_ocr.line_items"
              :key="index"
            >
              <td><input type="checkbox" v-model="item.participante" /></td>
              <td><input type="checkbox" v-model="item.maxFresh" /></td>
              <td>{{ item.description }}</td>
              <td>{{ item.sku }}</td>
              <td>{{ item.total }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-3 text-right">
        <button class="btn btn-success" @click="guardarParticipantes">
          Guardar cambios
        </button>
      </div>
    </b-modal>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";
import { ClientTable } from "vue-tables-2";
import JsonExcel from "vue-json-excel";

Vue.use(ClientTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  components: { Footer },
  data() {
    return {
      columns: [
        "status",
        "substatus",
        "no_ticket",
        "created_on_server",
        "user_id",
        "nombre",
        "email",
        "canal",
        //"monto_productos_participantes",
        "puntos_x_ticket",
        "id",
      ],
      options: {
        perPage: 100,
        headings: {
          id: "Ticket UID",
          nombre: "Nombre",
          email: "Email",
          status: "Estatus",
          substatus: "Subestatus", // 👈 Nuevo encabezado
          monto_productos_participantes: "Monto Productos",
          puntos_x_ticket: "Puntos por ticket",
          created_on_server: "Fecha Registro (Servidor)",
        },
      },
      tickets: [],
      users: {},
      monto: 0,
      puntos: 0,
      selectedTicket: null,
      productosParticipantes: [],
      columnsProductos: ["vendor", "sku", "description", "maxFresh"],
      optionsProductos: {
        perPage: 150,
        headings: {
          vendor: "Cadena",
          sku: "SKU",
          description: "Descripción",
          maxFresh: "Max Fresh",
        },
      },
    };
  },
  mounted() {
    AOS.init({ duration: 800, easing: "ease-in-out" });
    this.init();
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutReportes");
    },
    async init() {
      this.$store.dispatch("showLoader", true);
      await this.getUsers();
      await this.getTickets();
      this.getProductosParticipantes();
      this.$store.dispatch("showLoader", false);
    },
    async getUsers() {
      const docs = await usersCollection.get();
      this.users = {};
      docs.forEach((doc) => {
        const user = doc.data();
        try {
          if (user.created_on?.seconds) {
            user.created_on = moment
              .unix(user.created_on.seconds)
              .format("DD/MM/YYYY HH:mm:ss");
          }
        } catch {
          //
        }
        this.users[doc.id] = user;
      });
    },
    async getTickets() {
      const docs = await ticketsCollection.get();
      this.tickets = [];

      docs.forEach((doc) => {
        const ticket = doc.data();
        ticket.id = doc.id;
        ticket.substatus = ticket.substatus || ""; // 👈 Importante

        const user = this.users[ticket.user_id] || {};
        ticket.nombre = user.nombre || user.nombre_wa || "";
        ticket.email = user.email || "";
        ticket.created_on_server = ticket.created_on_server?.seconds
          ? moment
              .unix(ticket.created_on_server.seconds)
              .format("DD/MM/YYYY HH:mm:ss")
          : moment
              .unix(ticket.created_on.seconds)
              .format("DD/MM/YYYY HH:mm:ss");

        try {
          ticket.no_ticket = ticket.ticket_ocr.invoice_number || "";
        } catch (err) {
          //
          ticket.no_ticket = "";
        }

        this.tickets.push(ticket);

        delete ticket.monto_productos_participantes;
        delete ticket.validacion_monto;
        delete ticket.validacion_prods_participantes;
      });

      this.tickets.sort((a, b) =>
        a.created_on_server > b.created_on_server ? -1 : 1
      );
    },

    // ================================
    // MÉTODOS DE CAMBIO DE ESTATUS
    // ================================
    async changeStatusTicket(id, userId, value) {
      this.$store.dispatch("showLoader", true);

      const ok = await this.$store.dispatch("changeStatusTicketValidacion", {
        status: value,
        ticket_id: id,
        user_id: userId,
      });

      if (ok) {
        const ticket = this.tickets.find((t) => t.id === id);
        if (ticket) {
          ticket.status = value;

          // 🟢 Si el ticket se marca como "válido"
          if (value === "válido") {
            ticket.substatus = "";
            await this.$store.dispatch("changeSubstatusTicketValidacion", {
              substatus: "",
              ticket_id: id,
              user_id: userId,
            });
          }

          // 🔴 Si el ticket se marca como "inválido"
          if (value === "inválido") {
            ticket.puntos_x_ticket = 0;

            // Actualiza Firestore para que los puntos sean 0
            await this.$store.dispatch("changePuntosTicketValidacion", {
              puntos: 0,
              ticket_id: id,
              user_id: userId,
            });
          }
        }
      }

      this.$store.dispatch("showLoader", false);
    },
    async changeSubstatusTicket(id, userId, value) {
      if (!value) {
        alert("Selecciona un subestatus antes de actualizar.");
        return;
      }

      this.$store.dispatch("showLoader", true);

      const ok = await this.$store.dispatch("changeSubstatusTicketValidacion", {
        substatus: value,
        ticket_id: id,
        user_id: userId,
      });

      if (ok) {
        const ticket = this.tickets.find((t) => t.id === id);
        if (ticket) ticket.substatus = value;
      }

      this.$store.dispatch("showLoader", false);
    },

    async changeMontoTicket(id, userId, value) {
      this.$store.dispatch("showLoader", true);
      await this.$store.dispatch("changeMontoTicketValidacion", {
        monto: value,
        ticket_id: id,
        user_id: userId,
      });
      const ticket = this.tickets.find((t) => t.id === id);
      if (ticket) ticket.monto_productos_participantes = value;
      this.$store.dispatch("showLoader", false);
    },

    async changePuntosTicket(id, userId, value) {
      this.$store.dispatch("showLoader", true);
      await this.$store.dispatch("changePuntosTicketValidacion", {
        puntos: value,
        ticket_id: id,
        user_id: userId,
      });
      const ticket = this.tickets.find((t) => t.id === id);
      if (ticket) ticket.puntos_x_ticket = value;
      this.$store.dispatch("showLoader", false);
    },

    // ==========================
    // MODAL TICKET
    // ==========================
    verTicket(ticket) {
      // Creamos una copia profunda del ticket para no modificar el original hasta guardar
      this.selectedTicket = JSON.parse(JSON.stringify(ticket));

      // Función para parsear valores de Firebase a booleanos
      const isChecked = (val) => val === 1 || val === true;

      // Inicializamos los checkboxes según los valores de Firebase
      this.selectedTicket.ticket_ocr.line_items.forEach((item) => {
        item.participante = isChecked(item.participante);
        item.maxFresh = isChecked(item.maxFresh);
      });

      // Mostramos modal
      this.$bvModal.show("modal-detalle");
    },

    async guardarParticipantes() {
      if (!this.selectedTicket) return;

      // Aseguramos valores booleanos
      this.selectedTicket.ticket_ocr.line_items.forEach((item) => {
        item.participante = !!item.participante;
        item.maxFresh = !!item.maxFresh;
      });

      // Filtramos solo los participantes
      const participantes = this.selectedTicket.ticket_ocr.line_items.filter(
        (i) => i.participante
      );

      // Calculamos puntos correctamente
      const puntosTotales = participantes.reduce((sum, i) => {
        const total = Math.floor(i.total || 0);
        if (i.maxFresh) {
          return sum + total * 10; // 10x si es MaxFresh
        } else {
          return sum + total; // normal si no lo es
        }
      }, 0);

      // También calculamos monto de productos participantes (solo 1x)
      const montoParticipantes = participantes.reduce(
        (sum, i) => sum + Math.floor(i.total || 0),
        0
      );

      try {
        // Actualizar Firestore
        await ticketsCollection.doc(this.selectedTicket.id).update({
          monto_productos_participantes: montoParticipantes,
          puntos_x_ticket: puntosTotales,
          ticket_ocr: this.selectedTicket.ticket_ocr,
        });

        // Actualizar en memoria
        const t = this.tickets.find((t) => t.id === this.selectedTicket.id);
        if (t) {
          t.monto_productos_participantes = montoParticipantes;
          t.puntos_x_ticket = puntosTotales;
          t.ticket_ocr = JSON.parse(
            JSON.stringify(this.selectedTicket.ticket_ocr)
          );
        }

        // Enviar datos al backend
        const qData = this.selectedTicket.ticket_ocr.line_items.map((item) => ({
          description: item.description,
          vendor: this.selectedTicket.ticket_ocr?.vendor?.raw_name || "",
          maxFresh: item.maxFresh ? 1 : 0,
          sku: item.sku || "",
          participante: item.participante ? 1 : 0,
        }));

        this.$http
          .post(
            process.env.VUE_APP_API_URL + "guardar_participante.php",
            JSON.stringify(qData),
            {
              emulateJSON: true,
              headers: { "Content-Type": "text/plain" },
            }
          )
          .then(
            (response) => console.log("Participantes enviados:", response),
            (error) =>
              alert("Error al guardar participantes en la base de datos.")
          );

        this.$bvModal.hide("modal-detalle");
      } catch (err) {
        console.error("Error al guardar participantes:", err);
        alert("Error al guardar los cambios.");
      }
    },
    async getProductosParticipantes() {
      console.log("llamando productos participantes");
      try {
        const response = await this.$http.get(
          process.env.VUE_APP_API_URL + "get_productos_participantes.php"
        );
        this.productosParticipantes = response.data;
      } catch (err) {
        console.error("Error al traer productos participantes:", err);
      }
    },
  },
};
</script>

<style scoped>
.close-modal {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 28px;
  font-weight: bold;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1051;
}

.modal-detalle-custom .modal-content {
  padding-top: 40px;
}

.modal-title {
  margin-top: 0;
  margin-bottom: 0;
}
select option,
select {
  color: black !important;
}
.nav-tabs .nav-link {
  color: white !;
}
</style>
